// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__21p08","rootSuccess":"CompleteLink_rootSuccess__2-bTC","rootFailure":"CompleteLink_rootFailure__1OpGM","isDisabled":"CompleteLink_isDisabled__1wvtG"};